import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCreateReviewResetMutation({ projectId }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }) => {
      const response = await axios.post(`/reviews/${id}/reset`);

      return response.data;
    },
    onSuccess: () => {
      ['projectPersonnel', 'signatureStatus'].forEach((queryKeySegment) =>
        queryClient.invalidateQueries(['projects', projectId, queryKeySegment]),
      );
    },
  });
}
